export default __webpack_public_path__ + "static/media/Roboto-BoldItalic.be69c6f4.ttf";